import produce from 'immer'
import { assign, findIndex } from 'lodash'

import { areSameValue } from '../../../core/utils'

import { FETCH_PRIORITY_TASK_PROGRESS_COUNTS } from '../../../priority-tasks/redux/action-types'
import {
  ALLOCATE_AUTOMATICALLY,
  ASSIGN_MENU_CURATION_TASK_USER,
  DELETE_FAKE_MENU,
  FETCH_MENU_CURATION_TASKS,
  REMOVE_FROM_ALLOCATION,
  UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS,
  UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS,
} from '../action-types'
import { MENU_CURATION_TASKS_INITIAL_STATE } from '../initial-states'

const menuCurationTasksReducer = (
  state = MENU_CURATION_TASKS_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_MENU_CURATION_TASKS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_MENU_CURATION_TASKS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.menuCurationTasks

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_MENU_CURATION_TASKS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case ASSIGN_MENU_CURATION_TASK_USER.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case ASSIGN_MENU_CURATION_TASK_USER.COMPLETE:
      return produce(state, nextState => {
        const { assignUserToMenuCurationTask: menuCurationTask } =
          action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, menuCurationTask.id),
        )

        assign(nextState.data?.result[index], {
          ...menuCurationTask,
          isLoading: false,
          error: undefined,
        })
      })

    case ASSIGN_MENU_CURATION_TASK_USER.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case ALLOCATE_AUTOMATICALLY.START:
      return produce(state, nextState => {
        assign(nextState, {
          isAutomaticAllocationLoading: true,
          automaticAllocationError: undefined,
        })
      })

    case ALLOCATE_AUTOMATICALLY.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          isAutomaticAllocationLoading: false,
          automaticAllocationError: undefined,
        })
      })

    case ALLOCATE_AUTOMATICALLY.FAIL:
      return produce(state, nextState => {
        assign(nextState, {
          isAutomaticAllocationLoading: false,
          automaticAllocationError: action.error.message,
        })
      })

    case REMOVE_FROM_ALLOCATION.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case REMOVE_FROM_ALLOCATION.COMPLETE:
      return produce(state, nextState => {
        const { removeFromAllocation: menuCurationTask } = action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, menuCurationTask.id),
        )

        assign(nextState.data?.result[index], {
          ...menuCurationTask,
          isLoading: false,
          error: undefined,
        })
      })

    case REMOVE_FROM_ALLOCATION.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case DELETE_FAKE_MENU.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ menu }) =>
          areSameValue(menu.id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: true,
          error: undefined,
        })
      })

    case DELETE_FAKE_MENU.COMPLETE:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ menu }) =>
          areSameValue(menu.id, action.payload.variables.id),
        )

        nextState.data?.result?.splice(index, 1)
      })

    case DELETE_FAKE_MENU.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ menu }) =>
          areSameValue(menu.id, action.payload.id),
        )

        assign(nextState.data?.result[index], {
          isLoading: false,
          error: action.error.message,
        })
      })

    case UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS:
      return produce(state, nextState => {
        assign(nextState.persistedFilters, action.payload)
      })

    case UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS:
      return produce(state, nextState => {
        assign(nextState.nonUrlFilters, action.payload)
      })

    case FETCH_MENU_CURATION_TASKS.CLEANUP:
      return {
        ...MENU_CURATION_TASKS_INITIAL_STATE,
        persistedFilters: state.persistedFilters,
      }

    case FETCH_PRIORITY_TASK_PROGRESS_COUNTS.START:
      return produce(state, nextState => {
        assign(nextState, {
          priorityTaskProgressCounts: undefined,
        })
      })

    case FETCH_PRIORITY_TASK_PROGRESS_COUNTS.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          priorityTaskProgressCounts:
            action.payload.data.priorityTaskProgressCounts,
        })
      })

    case FETCH_PRIORITY_TASK_PROGRESS_COUNTS.FAIL:
      return produce(state, nextState => {
        assign(nextState, {
          priorityTaskProgressCounts: undefined,
        })
      })

    default:
      return state
  }
}

export default menuCurationTasksReducer
